<template>
    <div class="center" style="display:inline-block">
    <vs-tooltip>
      <vs-button
        size="small"
        icon
        :color="color"
        flat
        :active="active == 1"
        @click="getData"
      >
        <i :class="icon + ' icon--small'" ></i>
      </vs-button>
        <template #tooltip>
          {{ info }}
       </template>
    </vs-tooltip>
    </div>
</template>

<script>

    import axios from 'axios';

    export default {
      props: [
          'color',
          'icon',
          'url',
          'messageSuccess',
          'info'
      ],
      data () {
        return {
            active: 0
        }
      },
      methods:{
          async getData (){
            const params = {}

            try {
                const { data: response = null } = await axios.get(this.url , {
                    params
                })

                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Éxito',
                    text: this.messageSuccess ?? 'Se guardaron los registros',
                })
                
            } catch (error) {
                if (error.response.data && error.response.data.errors){
                    const data = error.response.data.errors
                    data.forEach(element => {
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: element
                        })
                    });

                }else{
                    this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: `Algo salió mal`
                    })
                }
            }
           


          }
      }
    }
  </script>

  <style scoped>
  /* .vs-button--icon i{ */
  .icon--small{
   font-size: .9rem;   
  }
  </style>